<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9558 7.56615L13.9418 10.6411C13.9418 10.6411 13.9601 5.61949 13.9632 4.20733C13.9637 3.55181 13.4314 3.01944 12.7758 3.01999C12.1198 3.01999 11.5885 3.55125 11.5885 4.20734C11.5864 5.5975 11.5773 10.641 11.5773 10.641L11.5902 3.08773C11.5908 2.4322 11.0584 1.89983 10.4029 1.90039C9.74677 1.90039 9.21552 2.43164 9.21552 3.08773C9.21395 4.78332 9.206 10.6409 9.206 10.6409L9.21552 5.32674C9.21608 4.67121 8.68371 4.13884 8.02818 4.1394C7.37209 4.1394 6.84084 4.67065 6.84084 5.32674L6.82404 12.7204L5.10305 10.9999C4.48447 10.3813 3.48242 10.3813 2.86384 10.9999C2.24526 11.6185 2.24526 12.6206 2.86384 13.2391C4.73505 15.1103 7.16601 18.5671 10.9568 18.5671C14.7477 18.5671 16.3162 15.8388 16.317 13.2692L16.331 7.56671C16.331 6.91062 15.7998 6.37937 15.1437 6.37937C14.4876 6.37937 13.9552 6.91062 13.9558 7.56615Z"
      stroke="currentColor"
      stroke-linejoin="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg {
  flex-shrink: 0;
}
</style>
